import React, { ReactElement, useState } from "react";
import {
    CartToastContext,
    CartToastContextValue,
    INITIAL_CART_TOAST_CONTEXT_VALUE,
} from "@cart-client/contexts/CartToastContext";

export function CartToastContextProvider(props: { children: React.ReactNode }): ReactElement {
    const [cartToastData, setCartToastData] = useState<CartToastContextValue["cartToastData"]>(
        INITIAL_CART_TOAST_CONTEXT_VALUE.cartToastData,
    );

    const cartToastContextValue = React.useMemo(
        () => ({
            cartToastData,
            setCartToastData,
        }),
        [cartToastData],
    );
    return <CartToastContext.Provider value={cartToastContextValue}>{props.children}</CartToastContext.Provider>;
}
